import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Button, Typography } from '@material-ui/core';

import { ActionContainer, ClientLogo, SubmitButton } from 'components';
import { Index, Login } from 'Links';

const PreventSignupSidebar: FC = () => (
  <div>
    <ClientLogo />
    <Typography variant="h4">
      <Trans i18nKey="auth:interestHeader" />
    </Typography>
    <Typography gutterBottom variant="subtitle1">
      <Trans i18nKey="auth:interestSubHeader" />
    </Typography>

    <ActionContainer>
      <SubmitButton component={Index} text={<Trans i18nKey="common:done" />} />
      <Button component={Login} fullWidth>
        <Trans i18nKey="auth:signUpLogin" />
      </Button>
    </ActionContainer>
  </div>
);

export default PreventSignupSidebar;
